import { useEffect, useState } from "react";
import { formatMoneyInput, sanitizeMoneyInput } from "../../lib/money";

interface Props {
  value: string;
  onChange: (rawValue: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  /**
   * Normalde MoneyInput odaktan çıkınca 35.000 formatına çevirir.
   * Satış ekranı gibi hızlı kullanılan alanlarda yazarken de binlik ayraç gösterilsin diye kullanılır.
   */
  formatWhileTyping?: boolean;
}

export default function MoneyInput({
  value,
  onChange,
  placeholder,
  disabled,
  className,
  formatWhileTyping = false,
}: Props) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState("");

  useEffect(() => {
    if (focused) return;
    setDraft(formatMoneyInput(value));
  }, [focused, value]);

  const displayPlaceholder = placeholder ? formatMoneyInput(placeholder) : "0";
  const displayValue = focused
    ? formatWhileTyping
      ? formatMoneyInput(draft) || draft
      : draft
    : formatMoneyInput(value);

  return (
    <div
      className={`flex items-center gap-2 rounded-farm border border-farm-border bg-farm-cream px-3 py-2.5 transition-colors focus-within:border-farm-earth ${
        disabled ? "opacity-60" : ""
      } ${className ?? ""}`}
    >
      <span className="font-body text-xs font-semibold text-farm-earth">₺</span>
      <input
        type="text"
        inputMode="decimal"
        value={displayValue}
        onFocus={() => {
          setFocused(true);
          setDraft(String(value ?? "").replace(".", ","));
        }}
        onBlur={() => {
          setFocused(false);
          setDraft(formatMoneyInput(value));
        }}
        onChange={(e) => {
          const next = e.target.value;
          // Yazarken formatlama acikken input uzerinde gorunen nokta binlik ayracidir.
          // Ornek: 1.234 yazisindan sonra 5 basilinca tarayici degeri 1.2345 olur.
          // Bunu decimal gibi okuyup 1,23e dusurmemek icin sadece bu modda binlik noktalarini temizliyoruz.
          const valueForParse = formatWhileTyping ? next.replace(/\./g, "") : next;
          const sanitized = sanitizeMoneyInput(valueForParse);
          setDraft(formatWhileTyping ? sanitized : next);
          onChange(sanitized);
        }}
        placeholder={displayPlaceholder}
        disabled={disabled}
        className="w-full bg-transparent font-body text-xs text-farm-brown placeholder:text-farm-muted/50 focus:outline-none"
      />
    </div>
  );
}
